import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const PrivacyPolicyPage: React.FC = () => {
  const { i18n } = useTranslation();

  // Get the appropriate HTML file based on current language
  const currentLanguage = i18n.language || 'en';
  const privacyUrl = `/legal/privacy-${currentLanguage}.html`;

  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Back navigation */}
        <div className="mb-6">
          <Link 
            to="/" 
            className="inline-flex items-center text-blue-600 hover:text-blue-800 font-medium"
          >
            ← Back to Home
          </Link>
        </div>

        {/* Iframe container */}
        <div className="bg-white rounded-lg shadow-lg overflow-hidden">
          <iframe
            src={privacyUrl}
            className="w-full h-screen border-0"
            title="Privacy Policy"
            style={{ minHeight: '800px' }}
          />
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicyPage;